import { render, staticRenderFns } from "./DashboardEficienciaPage.vue?vue&type=template&id=147a0804&scoped=true"
import script from "./DashboardEficienciaPage.vue?vue&type=script&lang=js"
export * from "./DashboardEficienciaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a0804",
  null
  
)

export default component.exports